import { loadVehiclesQuestion } from "./vehicles";
import { loadServicesQuestion } from "./services";
import { loadInvoicesQuestion } from "./invoices";
import { loadDeliveryNotesQuestion } from "./deliveryNotes";
import { loadSavingsQuestion } from "./savings";

export async function loadLiveQuestionData(questionId, vehicleId, ctx = {}) {
  return (
    (await loadVehiclesQuestion(questionId, vehicleId, ctx)) ||
    (await loadServicesQuestion(questionId, ctx)) ||
    (await loadInvoicesQuestion(questionId, ctx)) ||
    (await loadDeliveryNotesQuestion(questionId)) ||
    (await loadSavingsQuestion(questionId)) ||
    null
  );
}

export const LIVE_QUESTION_IDS = new Set([
  "totalVehicles",
  "servedVehicles",
  "mileageSummary",
  "vehiclePicker",
  "vehicleDetails",
  "servicesThisMonth",
  "upcomingServices",
  "overdueServices",
  "serviceHistory",
  "invoicesCurrentMonth",
  "invoicesLastMonth",
  "pendingInvoices",
  "invoiceSummary",
  "dnCurrentMonth",
  "dnLastMonth",
  "pendingDeliveryNotes",
  "deliveryNoteSummary",
  "totalSavings",
  "savingsThisMonth",
  "marketPriceVsSpent",
  "savingsByVehicle",
]);
